// globals: jQuery, TakePayment

import I4goIframeAbstract from './I4goFrameAbstract';

var i4goIframeTakePayment;

(function($) {

    i4goIframeTakePayment = new I4goIframeAbstract({
        formSelector: '#takePaymentForm',
        frameContainer: 'ccTakePaymentFormIframe',
        template: 'plain',
        cssRules: [
            "label{display:inline-block;font-size:12px;font-weight:bold;color:#333;font-family:Tahoma,Arial;width:115px}",
            "#container{margin-left:36px;}",
            "body{margin:0}",
            "input.form-control,select.form-control{border:1px solid #bebebe;}",
            "input{width:160px}",
            "#i4go_expirationMonth{width:98px;}",
            "#i4go_expirationYear{width:60px;}",
            "#i4go_cardType{width:162px;}",
            "form div{margin-bottom:4px;}",
            "#i4go_submit{width:284px;margin-top:0px;}",
            "label.error{width:282px}"
        ]
    });
    i4goIframeTakePayment.onSuccess = function() {
        TakePayment.pay($('#ccpayButton')[0]);
    };

})(jQuery);

export default i4goIframeTakePayment;
